import cfiLogic from '../../cfiLogic';

/**
 * @method getCfiForPixelOffset
 */
const getCfiForPixelOffset = (frame, pixelOffset) => {
  const frameDocument = frame.contentDocument;

  const bounds = frameDocument.body.getBoundingClientRect();

  const top = Math.max(pixelOffset, bounds.top);
  const left = Math.ceil(bounds.left);

  if (frameDocument.caretRangeFromPoint) {
    //not supported in IE 11
    let range = frameDocument.caretRangeFromPoint(left, top);

    if (!range || range.startContainer === frameDocument.documentElement) {
      // if no range is found revert to a manual search.
      const element = cfiLogic._manualElementSearch(frameDocument, top);
      range = frameDocument.createRange();
      range.selectNodeContents(element);
    }

    const start = range.startContainer;

    if (start.dataset && start.dataset.cfi) {
      return start.dataset.cfi;
    }

    if (range.startContainer === frameDocument) {
      return cfiLogic.getCfiForElement(frameDocument, range.startContainer);
    }

    return cfiLogic.getCfiForRange(frameDocument, range);
  }

  if (frameDocument.caretPositionFromPoint) {
    //firefox
    const caretPos = frameDocument.caretPositionFromPoint(
      Math.max(left, 0),
      Math.max(top, 0),
    );

    const range = frameDocument.createRange();

    // In most cases we should find a real element
    if (caretPos) {
      range.setStart(caretPos.offsetNode, caretPos.offset);
    } else {
      // A range created at the start of the body if there is no real element
      range.setStart(frameDocument.body, 1); // It will just be /4, but this avoids hard-coding it
    }

    return cfiLogic.getCfiForRange(frameDocument, range);
  }

  const element = cfiLogic._manualElementSearch(frameDocument, top);
  const range = frameDocument.createRange();
  range.selectNodeContents(element);

  return cfiLogic.getCfiForRange(frameDocument, range);
};

export default getCfiForPixelOffset;
